import React from 'react';
import type { BuiltResume } from '../../../resume-engine/types';
import { ResumeSection } from './ResumeSection';

interface Props {
  projects: BuiltResume['projects'];
  ats?: boolean;
}

export function ProjectsSection({ projects, ats = false }: Props) {
  if (!projects.length) return null;

  return (
    <ResumeSection title="Selected Projects">
      <div className="resume-project-list">
        {projects.map((project) => (
          <article key={project.title} className="resume-project-item">
            <div className="resume-project-header">
              <h3 className="resume-project-title">{project.title}</h3>
              {!ats && (project.github || project.liveDemo) && (
                <div className="resume-project-links">
                  {project.github && (
                    <a href={project.github} target="_blank" rel="noreferrer" className="resume-inline-link">
                      GitHub
                    </a>
                  )}
                  {project.github && project.liveDemo && (
                    <span className="resume-link-sep" aria-hidden>·</span>
                  )}
                  {project.liveDemo && (
                    <a href={project.liveDemo} target="_blank" rel="noreferrer" className="resume-inline-link">
                      Live Demo
                    </a>
                  )}
                </div>
              )}
            </div>
            <p className="resume-paragraph">{project.description}</p>
            {project.businessImpact && (
              <p className="resume-impact">
                <strong>Impact:</strong> {project.businessImpact}
              </p>
            )}
            <p className="resume-tech-line">
              <strong>Tech stack:</strong> {project.technologies.join(', ')}
            </p>
            {ats && project.liveDemo && <p className="resume-paragraph">Demo: {project.liveDemo}</p>}
          </article>
        ))}
      </div>
    </ResumeSection>
  );
}
